import React from 'react'
import './Style/Product.css'
import Logo from '../Image/logo.png'
import ReactHTMLTableToExcel from "react-html-table-to-excel";
function Product({data,info,total,discount,lastPrice}) {
  return <div className="table w-full md:px-10 px-2 mt-10 mb-10">
      <table id='table-invoice' className='md:w-10/12 w-full mb-10'>
        <thead>
            <tr>
                <th className="th-first">SL.</th>
                <th className="th-first">Description</th>
                <th className="th-center">Price</th>
                <th className="th-center">QTY</th>
                <th className="th-end">Total</th>
            </tr>
        </thead>

        {data.map((item,key)=>(
            <tr key={key}>
                <td>{item.id}</td>
                <td>{item.description} </td>
                <td> {item.price}$ </td>
                <td> {item.qty} </td>
                <td> {item.price * item.qty}$ </td>
            </tr>
        ))}
      </table>
    
    <div className='button-export-to-exsel'>
        <ReactHTMLTableToExcel
            id="test-table-xls-button"
            className="download-table-xls-button"
            table="table-invoice"
            filename="tablexls"
            sheet="tablexls"
            buttonText="Print To Excel"
        />
    </div>

    </div> 
}

export default Product